import { render, staticRenderFns } from "./bundling-cart-item.vue?vue&type=template&id=04211232&scoped=true"
import script from "./bundling-cart-item.vue?vue&type=script&lang=js"
export * from "./bundling-cart-item.vue?vue&type=script&lang=js"
import style0 from "./bundling-cart-item.vue?vue&type=style&index=0&id=04211232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04211232",
  null
  
)

export default component.exports